import { createStyles } from '@material-ui/core/styles';

export default createStyles({
    parentContainer: {
        width: '100%',
        padding: '0',
        boxSizing: 'border-box',
        height: 'calc(100% - 125px)',
        overflow: 'auto',
        flexGrow: 1
    },
    worksaleLineDataGrid: {
        height: '100%',
    },
    lineDetailIcon: {
        cursor: 'pointer'
    }
});
